class ResqueJob
  constructor: (options) ->
    @url = options.url
    @data = options.data
    @success = options.success
    @error = options.error

  start: ->
    $.ajax
      type: 'POST',
      url: @url,
      data: @data,
      global: false,
      success: (successResponse) =>
        @job_id = successResponse.job_id
        @inform()
        setTimeout @check(4000), 2000
      error: =>
        @error()

  stop: ->
    clearTimeout(@timeout) if @timeout
    # TODO: Cancel resque job

  check: (next_try) =>
    return () =>
      $.ajax
        type: 'POST'
        url: "/jobs/#{@job_id}/status"
        global: false
        success: (response) =>
          if response.status == 'completed'
            @success(response.results, @job_id)
          else if response.status == 'failed' || response.status == 'killed'
            console.log("Async job #{@job_id} failed or killed")
            @error(response)
          else
            @timeout = setTimeout @check(Math.min(next_try * 2, 12000)), next_try
        error: (response) =>
          @timeout = setTimeout @check(Math.min(next_try * 2, 12000)), next_try

  inform: ->
    return unless @job_id
    try
      origin = window.location.origin
      path = "jobs/#{@job_id}/status"
      url = "#{origin}/#{path}"
      console.log("Async job launched -- see status in #{url}")
    catch error
      console.log('Something went wrong with resque_job#inform')

window.ResqueJob = ResqueJob
